// src/reducers/BackupLoginReducer.js

const initialState = {
    isVerified: false,
    isLoading: false,
    errorMessage: "",
    rememberDeviceSaved: false,
  };
  
  const BackupLoginReducer = (state = initialState, action) => {
    switch (action.type) {
      case "BACKUP_CODE_VERIFY_LOADING":
        return {
          ...state,
          isLoading: true,
          isVerified: false,
          errorMessage: "",
        };
      case "BACKUP_CODE_VERIFY_SUCCESS":
        return {
          ...state,
          isLoading: false,
          isVerified: true,
        };
      case "BACKUP_CODE_VERIFY_ERROR":
        return {
          ...state,
          isLoading: false,
          errorMessage: action.payload,
        };
      case "BACKUP_REMEMBER_DEVICE_SUCCESS":
        return {
          ...state,
          rememberDeviceSaved: true,
        };
      case "BACKUP_LOGIN_RESET":
        return initialState;
      default:
        return state;
    }
  };
  
  export default BackupLoginReducer;
  